import * as commonFunctions from '~/utils/common';

export default (context, inject) => {
    inject('common', commonFunctions);
};
